/**
 * Greedy Non-Maximum Suppression.
 * @param {Array<{x1,y1,x2,y2,score}>} boxes
 * @param {number} iouThreshold
 */
export function nms(boxes, iouThreshold = 0.3) {
  if (boxes.length === 0) return [];

  const sorted = [...boxes].sort((a, b) => b.score - a.score);
  const kept = [];

  const areas = sorted.map(b => (b.x2 - b.x1) * (b.y2 - b.y1));
  const suppressed = new Uint8Array(sorted.length);

  for (let i = 0; i < sorted.length; i++) {
    if (suppressed[i]) continue;
    kept.push(sorted[i]);

    for (let j = i + 1; j < sorted.length; j++) {
      if (suppressed[j]) continue;
      const iou = computeIoU(sorted[i], sorted[j], areas[i], areas[j]);
      if (iou > iouThreshold) suppressed[j] = 1;
    }
  }

  return kept;
}

function computeIoU(a, b, areaA, areaB) {
  const ix1 = Math.max(a.x1, b.x1);
  const iy1 = Math.max(a.y1, b.y1);
  const ix2 = Math.min(a.x2, b.x2);
  const iy2 = Math.min(a.y2, b.y2);
  const inter = Math.max(0, ix2 - ix1) * Math.max(0, iy2 - iy1);
  return inter / (areaA + areaB - inter);
}
